export default "__VITE_ASSET___i3TxVc5__"